import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  fetchPartnerMarketLeasing,
  IFetchPartnerMarketLeasingParams,
} from 'legacy/lut/services/partner360/marketInfo/fetchPartnerMarketLeasing'
import { map1018ToMarketLeasing } from 'legacy/lut/services/partner360/marketInfo/mappings/map1018ToMarketLeasing'

import { YEAR_WHEN_GP_APPEARS } from '../../../globalPartner/constants'
import { REQUEST_PARTNER_MARKET_LEASING } from '../constants'
import { IPartnerMarketLeasing } from '../models/IMarketInfo'

export const requestPartnerMarketLeasing = createAsyncThunk<
  IPartnerMarketLeasing,
  IFetchPartnerMarketLeasingParams
>(
  REQUEST_PARTNER_MARKET_LEASING,
  async (params) => {
    const data = await fetchPartnerMarketLeasing(params)
    return map1018ToMarketLeasing(data)
  },
  {
    condition({ partnerId, programType, fYear }) {
      if (!partnerId || !programType || !fYear) {
        return false
      }

      if (partnerId.startsWith('GP') && fYear < YEAR_WHEN_GP_APPEARS) {
        return false
      }

      return
    },
  }
)
